import "../css/app.css";
import {bindShowModal, reload} from "./utils";
import {enhanceAppSelects} from "./select";
import {createApp} from "vue";
import TenantLogo from "../vue/TenantLogo.vue";
import TemplateBackgroundUpload from "../vue/TemplateBackgroundUpload.vue";

function initSidebar() {
    const workspace = document.querySelector<HTMLElement>('[data-sidebar-state]')
    const toggle = document.querySelector<HTMLButtonElement>('[data-sidebar-toggle]')
    const openButton = document.querySelector<HTMLButtonElement>('[data-sidebar-open]')
    const closeButton = document.querySelector<HTMLButtonElement>('[data-sidebar-close]')

    if (!workspace || !toggle || !openButton || !closeButton) {
        return
    }

    const storageKey = 'app-sidebar-state'
    const media = window.matchMedia('(max-width: 767px)')
    let state: 'expanded' | 'collapsed' = 'expanded'

    try {
        const savedState = window.localStorage.getItem(storageKey)
        if (savedState === 'expanded' || savedState === 'collapsed') {
            state = savedState
        }
    } catch {
        // The sidebar remains usable when browser storage is unavailable.
    }

    const updateDesktopState = () => {
        workspace.dataset.sidebarState = state
        const expanded = state === 'expanded'
        const label = expanded ? 'Свернуть меню' : 'Развернуть меню'
        toggle.setAttribute('aria-label', label)
        toggle.setAttribute('title', label)
        toggle.setAttribute('aria-expanded', String(expanded))
    }

    const closeMobileSidebar = () => {
        workspace.classList.remove('is-sidebar-open')
        openButton.setAttribute('aria-expanded', 'false')
        openButton.setAttribute('aria-label', 'Открыть меню')
    }

    updateDesktopState()

    toggle.addEventListener('click', () => {
        state = state === 'expanded' ? 'collapsed' : 'expanded'
        updateDesktopState()
        try {
            window.localStorage.setItem(storageKey, state)
        } catch {
            // Keep the current in-memory setting if storage is unavailable.
        }
    })

    openButton.addEventListener('click', () => {
        const isOpen = workspace.classList.toggle('is-sidebar-open')
        openButton.setAttribute('aria-expanded', String(isOpen))
        openButton.setAttribute('aria-label', isOpen ? 'Закрыть меню' : 'Открыть меню')
    })

    closeButton.addEventListener('click', closeMobileSidebar)
    workspace.querySelectorAll<HTMLAnchorElement>('.app-sidebar a').forEach((link) => {
        link.addEventListener('click', () => {
            if (media.matches) {
                closeMobileSidebar()
            }
        })
    })

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMobileSidebar()
        }
    })

    media.addEventListener('change', () => {
        closeMobileSidebar()
        updateDesktopState()
    })
}

initSidebar()
enhanceAppSelects(document)

document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
        return
    }

    const closeButton = event.target.closest('[data-alert-close]')
    closeButton?.closest('.app-alert')?.remove()
})

export function TenantList() {
    const options = {
        afterClose() {
            reload()
        },
        beforeShow(dialog: HTMLDialogElement, response: any) {
            const logoContainer = dialog.querySelector('#js-logo')
            if (logoContainer) {
                createApp(TenantLogo, {
                    id: response.model?.logo_id,
                    url: response.logo_url,
                    formName: "TenantForm"
                }).mount(logoContainer)
            }
        }
    }

    bindShowModal('.js-show-modal', options)
}

export function TenantProfile() {
    const container = document.querySelector<HTMLElement>('#js-profile-logo')
    if (!container) return

    createApp(TenantLogo, {
        id: Number(container.dataset.logoId || 0),
        url: container.dataset.logoUrl || '',
        formName: 'ProfileForm',
    }).mount(container)
}

export function TemplateList() {
    bindShowModal('.js-show-modal', {
        afterClose() {
            reload()
        },
        beforeShow(dialog: HTMLDialogElement) {
            const container = dialog.querySelector<HTMLElement>('#js-template-upload')
            if (!container) return

            createApp(TemplateBackgroundUpload, {
                uploadId: Number(container.dataset.uploadId || 0),
                uploadUrl: container.dataset.uploadUrl || '',
                formName: container.dataset.formName || 'TemplateForm',
                minImageWidth: Number(container.dataset.minImageWidth || 0),
                minImageHeight: Number(container.dataset.minImageHeight || 0),
            }).mount(container)
        },
    })
}

export function UserList() {
    bindShowModal('.js-show-modal', {
        afterClose() {
            reload()
        }
    })
}

export function OrderList() {
    bindShowModal('.js-show-modal', {
        afterClose() {
            reload()
        }
    })
}

export function CertificateList() {
    bindShowModal('.js-show-modal', {
        afterClose() {
            reload()
        }
    })
}

export function PromoCodeList() {
    bindShowModal('.js-show-modal', {
        afterClose() {
            reload()
        }
    })
}
